import React from 'react'
import {Route, Routes} from 'react-router-dom'
import {DocsMain} from './DocsMain'
import {DocDetails} from './DocDetails'
import {DraftsTable} from './Drafts'
import {DraftAndSentReq} from './Draft&SentReq'

const DocsRoute = () => {
  return (
    <Routes>
      <Route path='/' element={<DraftAndSentReq />} />
      {/* <Route
        path='/'
        element={
          <div className='d-flex gap-5'>
            <DraftsTable />
            <DocsMain />
          </div>
        }
      /> */}
      <Route path='/:req_id' element={<DocDetails />} />
      <Route path='*' element={<DocsMain />} />
    </Routes>
  )
}

export {DocsRoute}
